// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__37znl","header":"ReportDetails_header__34Rub","title":"ReportDetails_title__3-ble","left":"ReportDetails_left__2cPFy"};